import amplifyConfigurations from './amplifyConfigurations';

export default {
  dev: {
    BaseUrl: 'https://apidev.direcional.com.br/portalapi/v1/',
    BaseUrlNotSensedia:
      'https://ootbw9q2sa.execute-api.us-east-1.amazonaws.com/Dev/',
    AmplifyConfigure: amplifyConfigurations['dev'],
    BucketImages:
      'https://portal-direcional-bucket-image.s3.amazonaws.com/public/',
    BucketName: 'portal-direcional-bucket-image',
    environment: 'DEV',
    BaseUrlDocumentsSindico:
      'https://homologacao.sg2sistemas.com.br/redirecionamento/base2',
    BaseUrlD4Sign: 'https://sandbox.d4sign.com.br/embed',
  },
  qa: {
    BaseUrl: 'https://apihmg.direcional.com.br/portalapi/v1/',
    // BaseUrlNotSensedia :
    //   "https://ootbw9q2sa.execute-api.us-east-1.amazonaws.com/QA/";
    AmplifyConfigure: amplifyConfigurations['qa'],
    BucketImages:
      'https://portal-direcional-bucket-image-qa.s3.amazonaws.com/public/',
    BucketName: 'portal-direcional-bucket-image-qa',
    environment: 'QA',
    BaseUrlDocumentsSindico:
      'https://homologacao.sg2sistemas.com.br/redirecionamento/base2',
    BaseUrlD4Sign: 'https://sandbox.d4sign.com.br/embed',
  },
  stage: {
    BaseUrl: 'https://apistage.direcional.com.br/portalapi/v1/',
    // BaseUrlNotSensedia :
    //   "https://ootbw9q2sa.execute-api.us-east-1.amazonaws.com/Stage/",
    AmplifyConfigure: amplifyConfigurations['stage'],
    BucketImages:
      'https://portal-direcional-bucket-image-stage.s3.amazonaws.com/public/',
    BucketName: 'portal-direcional-bucket-image-stage',
    environment: 'Stage',
    BaseUrlDocumentsSindico:
      'https://homologacao.sg2sistemas.com.br/redirecionamento/base2',
    BaseUrlD4Sign: 'https://sandbox.d4sign.com.br/embed',
  },
  prod: {
    BaseUrl: 'https://api.direcional.com.br/portalapi/v1/',
    // BaseUrlNotSensedia :
    //   "https://ootbw9q2sa.execute-api.us-east-1.amazonaws.com/Prod/",
    AmplifyConfigure: amplifyConfigurations['prod'],
    BucketImages:
      'https://portal-direcional-bucket-image-prod.s3.amazonaws.com/public/',
    BucketName: 'portal-direcional-bucket-image-prod',

    environment: 'Prod',
    BaseUrlDocumentsSindico: 'https://app.guiare.com/redirecionamento/base2',
    BaseUrlD4Sign: 'https://secure.d4sign.com.br/embed',
  },
  testes: {
    BaseUrl: 'https://apitest.direcional.com.br/portalapi/v1/',
    // BaseUrlNotSensedia : BaseUrl,
    AmplifyConfigure: amplifyConfigurations['testes'],
    BucketImages:
      'https://portal-direcional-bucket-image-teste.s3.amazonaws.com/',
    BucketName: 'portal-direcional-bucket-image-teste',
    environment: 'Testes',
    BaseUrlDocumentsSindico:
      'https://homologacao.sg2sistemas.com.br/redirecionamento/base2',
    BaseUrlD4Sign: 'https://sandbox.d4sign.com.br/embed',
  },
};
